<template>
  <div>
    <div v-if="version === 'V3'">
      version {{ version }}
    </div>
    <v-container fluid class="py-6 px-">
      <report-chart
          v-show="this.user[0].name !== 'dmytro.miroshnykov'"
          :report-period="innerTabs[activeTab].options ? innerTabs[activeTab].options.periodType || 'Today' : 'Today'"
          :totals="chart.totals"
          :drillDownId="innerTabs[activeTab].id"
          :isDataFetched="chart.isDataFetched"
          :isCompared="chart.isCompared"
          :version="version"
      />
    </v-container>
    <v-tabs class="reports_affiliates" v-model="activeTab">
      <v-tab :key="tab.value + index" v-for="(tab, index) in innerTabs">
        <span v-if="tab.value === params.value">{{name}}</span>
        <v-tooltip top open-delay="1000">
          <template v-slot:activator="{ on, attrs }">
            <span v-if="tab.value !== params.value" class="co-tab-title" v-bind="attrs" v-on="on">
              <span><v-icon color="accent">{{ getTabIcon(tab.type) }}</v-icon>: </span>
              <span v-for="(tabName, i) in innerTabsName[index]" :key="`${tabName.type}_${i}`">
                <v-icon small color="white">{{getTabIcon(tabName.type)}}</v-icon> {{tabName.name}}
                <v-icon v-if="i < innerTabsName[index].length - 1" small color="white">mdi-menu-right</v-icon>
              </span>
            </span>
          </template>
          <span v-if="tab.value !== params.value">
            <span><v-icon color="accent">{{ getTabIcon(tab.type) }}</v-icon>: </span>
            <span v-for="(tabName, i) in innerTabsName[index]" :key="`${tabName.type}_${i}`">
              <v-icon small color="white">{{getTabIcon(tabName.type)}}</v-icon> {{tabName.name}}
              <v-icon v-if="i < innerTabsName[index].length - 1" small color="white">mdi-menu-right</v-icon>
            </span>
          </span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-icon @click="removeTab(tab, index)" v-if="index === 0 ? false : true" color="#fff" size="18" class="ml-3"> mdi-close </v-icon>
      </v-tab >
      <v-tabs-items v-model="activeTab">
        <v-tab-item :key="tab.key" v-for="(tab, index) in innerTabs">
          <new-tab
              :drillDown="tab"
              @goDown="addTab"
              @updateTab="updateTab"
              :is-active="activeTab === index"
              @updateTotals="chart.totals = $event"
              @isChartDataFetched="chart.isDataFetched = $event"
              @isCompared="chart.isCompared = $event"
              :timePeriodType="tab.options ? tab.options.periodType || 'Today' : 'Today'"
              :timePeriod="{from: tab.options && tab.options.fromDate, to: tab.options && tab.options.toDate}"
              :timePeriodComp="{from: tab.options && tab.options.fromDateComp, to: tab.options && tab.options.toDateComp}"
              :additionalColumns="additionalColumns"
              :isShowBlacklisted="isShowBlacklisted"
              :version="version"
              :reportType="reportType"
              @loading-started="$emit('loading-started')"
              @loading-complete="$emit('loading-complete')"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import ReportChart from '../ReportChart';
import {mapState} from "vuex";

  export default {
    props: {
      params: Object,
      additionalColumns: Array,
      name: String,
      version: String,
      isShowBlacklisted: Boolean,
      reportType: {
        type: String,
        default: 'click'
      }
    },
    components: {
      ReportChart
    },
    data: vm=>({
      activeTab: 0,
      table: {
        drillDowns: [
          {type: 'offer_id', name: 'Offer', icon: 'mdi-offer'},
          {type: 'program_id', name: 'Program', icon: 'mdi-open-in-app'},
          {type: 'campaign_id', name: 'Campaign', icon: 'mdi-bullhorn-outline'},
          {type: 'sub_campaign', name: 'Sub campaign', icon: 'mdi-bullhorn'},
          {type: 'geo', name: 'Geo', icon: 'mdi-earth'},
          {type: 'day', name: 'Day', icon: 'mdi-calendar-today'},
          {type: 'week', name: 'Week', icon: 'mdi-calendar-week'},
          {type: 'hour', name: 'Hour', icon: 'mdi-hours-24'},
          {type: 'isp', name: 'ISP', icon: 'mdi-spider-web'},
          {type: 'affiliate_id', name: 'Affiliate', icon: 'mdi-account'},
          {type: 'advertiser_id', name: 'Advertiser', icon: 'mdi-briefcase-account'},
          {type: 'os', name: 'Os', icon: 'mdi-microsoft-windows-classic'},
          {type: 'affiliate_manager_id', name: 'AM', icon: 'mdi-account-tie'},
          {type: 'advertiser_manager_id', name: 'BD!', icon: 'mdi-briefcase-account'},
          {type: 'device', name: 'Device', icon: 'mdi-cellphone-link'},
          {type: 'vertical_name', name: 'vertical_name', icon: 'mdi-align-vertical-bottom'},
          {type: 'referer', value: 'referer', name: 'referer', icon: 'mdi-arrow-expand-right'},
          {type: 'tier', value: 'tier', name: 'Tier', icon: 'mdi-medal'},
          {type: 'highest_tier', value: 'highest_tier', name: 'Highest Tier', icon: 'mdi-medal-outline'},
          {type: 'custom', value: 'custom', name: 'Custom', icon: 'mdi-tune'},
          {type: 'img', value: 'img', name: 'img', icon: 'mdi-tune'},
          {type: 'kw', value: 'kw', name: 'kw', icon: 'mdi-tune'},
          {type: 'cid', value: 'cid', name: 'cid', icon: 'mdi-import'},
          {type: 'lid', value: 'lid', name: 'lid', icon: 'mdi-export'},
          {type: 'state', value: 'state', name: 'state', icon: 'mdi-earth-box'},
          {type: 'source_url', value: 'source_url', name: 'Source URL', icon: 'mdi-link-plus'},
        ],
      },
      innerTabs: [],
      innerTabsName: [],
      interval: {},
      value: 0,
      chart: {
        isCompared: false,
        isDataFetched: false,
        totals: {},
        reportPeriod: 'last7days',
        dates: [],
        profile: {
          timezone: [],
        },
        reportPeriodItems: [
          { text: 'Last 7 Days', value: 'last7days' },
          { text: 'Last 30 Days', value: 'last30days' },
          { text: 'This Month', value: 'thisMonth' },
          { text: 'Last Month', value: 'lastMonth' },
          { text: 'Custom Period', value: 'custom' },
        ],
      },
    }),

    created() {
      if (!this.params || !this.params.value) {
        console.warn('ReportTab: invalid params!', this.params);
        return;
      }
      const savedTabs = JSON.parse(localStorage.getItem(`reports_${this.params.value}`)) || null;
      if (savedTabs && savedTabs.innerTabs && savedTabs.innerTabsName) {
        this.innerTabs = savedTabs.innerTabs;
        this.innerTabsName = savedTabs.innerTabsName;
      } else {
        this.innerTabs.push(this.params)
        this.innerTabsName.push([{name: this.name}]);
      }
      this.saveReports()
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    computed: {
      ...mapState('user', ['user']),
    },
    watch: {
      activeTab() {}
    },
    methods: {
      updateDates() {
        (this.$refs.menu).save(this.dates);
        this.reportDates = this.dates;
      },
      saveReports() {
        localStorage.setItem(
            `reports_${this.params.value}`,
            JSON.stringify({
              innerTabs: this.innerTabs,
              innerTabsName: this.innerTabsName
            })
        );
      },
      getTabIcon(type) {
        return this.table.drillDowns.find(dd => dd.type === type).icon
      },
      addTab(tab, options) {
        // todo fix tab keys
        // const tabIndex = -1;
        const tabIndex = this.innerTabs.findIndex(t => t.key === tab.key);
        if (tabIndex >= 0) {
          this.activeTab = tabIndex;
        } else {
          this.innerTabs.push({
            key: tab.key,
            id: tab.id,
            value: tab.value,
            name: tab.name,
            type: tab.type,
            entity: tab.entity,
            breadCrumbs: tab.breadCrumbs || [],
            options
          })
          const names = [];
          for(let i = 0; i < tab.breadCrumbs.length; i++) {
            names.push({type: tab.breadCrumbs[i].field, name: tab.breadCrumbs[i].name})
          }
          this.innerTabsName.push(names)
          this.saveReports();
        }
      },
      updateTab(tabKey, options) {
        for(let i = 0; i < this.innerTabs.length; i++) {
          if(this.innerTabs[i].key === tabKey) {
            this.innerTabs[i].options = options;
            break;
          }
        }
        this.saveReports()
      },
      removeTab(tab, index) {
        this.innerTabs.splice(index, 1)
        this.innerTabsName.splice(index, 1)
        this.saveReports()
      },
    },
  }
</script>

<style lang="sass">
  .theme--light.v-tabs-items
    background-color: transparent !important
    /*tabs*/
  .reports_affiliates.theme--light.v-tabs>.v-tabs-bar
    height: 38px
    width: fit-content
  .reports_affiliates.theme--light.v-tabs>.v-tabs-bar .v-tab
    text-transform: capitalize
    font-size: 0.7rem
    font-weight: 600
    background-color: rgba(58, 56, 82, 0.8)
    border-radius: 4px 4px 0 0
    margin-right: 5px
    color: #FFFFFF !important
  .reports_affiliates.theme--light.v-tabs>.v-tabs-bar .v-tab--active
    background-color: #3A3852
  .theme--light.v-tabs .v-tab--active:before, .theme--light.v-tabs .v-tab--active:hover:before, .theme--light.v-tabs .v-tab:focus:before
    background-color: #3A3852
  .time_period_wrap
    background: #3A3852
    .col-12
      padding-top: 8px
      padding-bottom: 8px
    .v-text-field.v-text-field--solo .v-input__control
      width: 135px !important
      min-height: 32px !important
    .time_period_title
      color: #FFFFFF
      font-size: 14px
      font-weight: 700
      letter-spacing: 0.2px
      padding-right: 10px

    /*datepicker*/
    .datepicker_title
      line-height: 90px
      color: #FFFFFF
      font-size: 14px
      font-weight: 700
      letter-spacing: 0.2px
      padding-right: 10px
    .theme--light.v-icon
      color: #FFFFFF
    .theme--light.v-input input
      color: #FFFFFF
    .theme--light.v-text-field>.v-input__control>.v-input__slot:before
      border-color: #FFFFFF !important

  /*table*/
  .v-data-table__wrapper
    /*min-height: 500px*/
  .updateData
    font-size: 14px
    font-style: italic
    color: #ACC3CF
    position: absolute
    bottom: 5px
    left: 450px

  .co-tab-title
    text-align: left
    overflow: hidden
    white-space: nowrap

</style>
